/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "arrow-right-bold-a784dab4--sprite",
  "use": "arrow-right-bold-a784dab4--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"arrow-right-bold-a784dab4--sprite\"><rect width=\"36\" height=\"36\" fill=\"#fff\" opacity=\"0\" /><g transform=\"translate(10.001 9.998)\"><path d=\"M516.849,1304.591a1.389,1.389,0,0,1-.08.5.651.651,0,0,1-.08.28,1.976,1.976,0,0,1-.42.64l-6,6a2,2,0,0,1-2.82,0,1.992,1.992,0,0,1,0-2.82l2.58-2.6h-7.18a2,2,0,0,1,0-4h7.18l-2.58-2.58a1.994,1.994,0,1,1,2.82-2.82l6,6A1.981,1.981,0,0,1,516.849,1304.591Z\" transform=\"translate(-500.849 -1296.606)\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
